<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>

    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">健身俱乐部引流锁客经典案例</div>
        <div class="text text3">
某健身俱乐部成立于2016年年初，是当地仅有的一家健身俱乐部，占地1200平方，投资200万元，专业教练15余名。健身俱乐部内部的装修在健身馆中属于一般，不仅内部装修宜人，健身设备完善，而且健身馆内的可选课程也相当丰富。
<br>
但是，健身馆一直面临客户流失问题——锁客环节薄弱。因此，米创科技为其设计了“0元健身”的活动，帮助其引流锁客。此次活动不仅解决锁客难的问题，还使健身馆的月营业额显著提升！
<br>

方案设计思路
<br>

①    锁客效率低，客流量不够，所以首先要解决大量引流的问题。
<br>

②    如何快速长久锁定客源，让顾客成为持续消费的会员。
<br>

实操过程
<br>

——设定活动文案——
<br>

①   引流文案：重装升级“0元健身”风暴来袭！
<br>

②   截流文案：大型百人团购方案
<br>


——引流方案设计——
<br>

引流实操要点
<br>

①    引流前预热：
<br>

预热时间：举办活动前提前半个月进行活动预热，在线上、线下各个渠道铺满活动的宣传页。
<br>
 
老客户预热
<br>

提前以短讯、电话、微信等形式通知老客户“xx健身举办0元健身”的活动。
<br>
 
②  线上引流
<br>

朋友圈引流
<br>
加微信或打电话，配图转发至朋友圆集费18个,可领100元话费充值卡一张 (联通、电信、移动均可使用)限199名，活动真实有效,领完为止!
 
<br>
③  线下引流
<br>
宣传页引流
<br>
制作活动海报以及宣传页。在小区门口人流集中处进行分发单页并设置易拉宝或粘贴活动海报。
<br>
 
氛围引流
<br>
——门店前，设置店内工作人员在店前带动气氛，烘托出活动盛大的氛围，当有客户进店的时候也要有对应的欢呼，欢迎的气氛。
<br>
——将充值免费送的礼品，全部摆在店内明显的地方，消费者只要进店就能看见
<br>
产品培训
<br>
店内所有参与运营的人员每个人至少熟悉三款能够进行京东、天猫等网站比价的产品，能够熟练介绍，并适时推荐给消费者，提高消费者对礼品的信任感。
<br>
\ 引流小结 /
<br>
什么样的店客流量大？
<br>
 
有口碑、老客户多；活动力度大，大到没有同类型的店敢与你店内的活动力度一样。
<br>
 
用礼品引流，一定要注意换位思考。如果你作为客户，你看见这样引流产品，你会有到店领奖品的想法吗！
<br>
 
除了换位思考之外，还可以通过调研的方式询问，可以询问店员、常来的老客户，看这些人对引流产品的反应再抉择。
<br>
—— 截流方案设计 ——
<br>
 
① 截流一定要有“三限原则”。
<br>
充值999元送1万元！，健身满一年后全额返现！
<br>
万元礼包清单：
<br>
1.送价值2980元净之宝净水器一台
<br>
2.送健身购物积分1000分，价值1000元，可全额购物
<br>
3.送健身购物商城价值1000元的代金券
<br>
4.送话费充值卡1000元(电信、移动、联通均可使用)
<br>
5.送健身俱乐部健身年卡一张(价值1680元)
<br>
6.送D-H少ル少儿爵士舞月卡一张(价值398元)
<br>
7.送非凡美容套装(价值2080元)
<br>
8.送非凡美发护理一套(价值398元)
<br>
9.送非凡美发店(新区店)洗头卡一张(价值150元)
<br>
10.送震达路拳道月卡一张(价值380元)
<br>
11.送大汉火锅店充值卡480元
<br>
12.送一脚定天下足疗卡5次(价值500元)
<br>
13.送酒点半酒吧啤酒储值卡(价值1000元)
<br>
（获取米创科技赠品采购平台报价）
<br>
\ 截流小结 /
<br>
如何截流异业店客流？
<br>
很简单的做法就是资源置换，形成异业联盟，抱团取暖。
<br>
健身俱乐部选择与少儿教育、美容养生、餐饮等行业形成异业联盟，完全可以避免出现与这些行业的客户群体冲突的情况发生。
<br>
选择不同行业、不同层次的商业主体联合，联盟的商业主体之间，既存在竞争又存在合作关系。彼此合作共赢，共享客户资源，这才是异业联盟各商业主体的共同目标。
<br>
营销方案仅供参考，落地执行请以实际效果为准!
        </div>
        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div @click="shareToQQ()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"></div>
            <div @click="WeixinJSBridge()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"></div>
            <div  @click="shareToMicroblog()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">用2个步骤，一周新增628客户，营收91万！</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
       //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1"

      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq = "https://api.pwmqr.com/qrcode/create/?url=" +

          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(qqqq, 'newwindow', 'height=400,width=400,top=200,left=600');

    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1"
      };
      var wwww = "https://api.pwmqr.com/qrcode/create/?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(wwww, 'newwindow', 'height=400,width=400,top=200,left=600');
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/"
      };
      //跳转地址
      var bbbb =  "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"

        window.open(bbbb, 'newwindow', 'height=1000,width=1000,top=200,left=100');
    },
     tiaozhuan(e){
      if( e == 3){
        this.$router.push({
        path: "/alxq5",
      });
      }else if( e == 2){
      this.$router.push({
        path: "/alxq4",
      });
      }else if( e == 1){
        this.$router.push({
        path: "/alxq2",
      });
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url('../../assets/images/1625137306(1).jpg') no-repeat center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/alxq3/index.vue